import { useCallback } from 'react'
import { useForm } from 'react-hook-form'
import { useUpdateStorageCapacityMutation } from '@crew/apis/contract/contractApis'
import { MINIMUM_STORAGE_CAPACITY } from '@crew/configs/constants'

export type FormValues = {
  storageUpgrade: number
}
const formInitialValues: FormValues = {
  storageUpgrade: MINIMUM_STORAGE_CAPACITY,
}
export const useContractChangeStoragePage = () => {
  const { control, handleSubmit, getValues, setValue } = useForm<FormValues>({
    criteriaMode: 'all',
    defaultValues: formInitialValues,
  })

  // Get update storage capacity function
  const [
    updateStorageCapacityMutation,
    { isLoading: isLoadingUpdateStorageCapacity },
  ] = useUpdateStorageCapacityMutation()

  // Update storage capacity process
  const updateStorageCapacity = useCallback(
    async (storageCapacity: number) => {
      await updateStorageCapacityMutation({
        storageCapacity: storageCapacity,
      }).unwrap()
    },
    [updateStorageCapacityMutation]
  )

  return {
    control,
    handleSubmit,
    getValues,
    setValue,
    updateStorageCapacity,
    isLoadingUpdateStorageCapacity,
  }
}
